import {
  GET_ADMIN_USERS,
  GET_ADMIN_USERS_SUCCESS,
  GET_ADMIN_USERS_ERROR,
  GET_OLD_ADMIN_USERS,
  GET_OLD_ADMIN_USERS_SUCCESS,
  GET_OLD_ADMIN_USERS_ERROR,
  UPDATE_CLIENTS,
  UPDATE_CLIENTS_SUCCESS,
  UPDATE_CLIENTS_ERROR,
  GET_CLIENT_USERS_BY_ACCOUNT_ID,
  GET_CLIENT_USERS_BY_ACCOUNT_ID_SUCCESS,
  GET_CLIENT_USERS_BY_ACCOUNT_ID_ERROR,
  RESET_LAST_COMPLETED_ACTION,
  CREATE_ADMIN_RECENT_VISIT,
  CREATE_ADMIN_RECENT_VISIT_SUCCESS,
  CREATE_ADMIN_RECENT_VISIT_ERROR,
  GET_ADMIN_RECENT_VISIT,
  GET_ADMIN_RECENT_VISIT_SUCCESS,
  GET_ADMIN_RECENT_VISIT_ERROR,
  GET_REGISTRATION_PENDING_USERS,
  GET_REGISTRATION_PENDING_USERS_SUCCESS,
  GET_REGISTRATION_PENDING_USERS_ERROR,
  SEND_ADMIN_CLIENT_INVITE_MAIL,
  SEND_ADMIN_CLIENT_INVITE_MAIL_SUCCESS,
  SEND_ADMIN_CLIENT_INVITE_MAIL_ERROR,
  DELETE_REGISTRATION_PENDING_USER,
  DELETE_REGISTRATION_PENDING_USER_SUCCESS,
  DELETE_REGISTRATION_PENDING_USER_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  admin_manage_clients: [],
  admin_manage_clients_loading: false,
  admin_manage_clients_error: null,
  admin_users: [],
  loading: false,
  last_page_fetched: 0,
  total_number_of_pages: 0,
  total_client_users: 0,
  client_users_by_account: null,
  client_users_by_account_loading: false,
  client_users_by_account_error: null,
  admin_recent_visits: [],
  registration_pending_users: [],
  registration_pending_users_loading: false,
  registration_pending_users_error: null,
  invite_mailer_loading: false
}

const AdminUsers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_USERS:
      return {
        ...state,
        admin_manage_clients_loading: true,
        admin_manage_clients: state.admin_manage_clients,
        last_page_fetched: state.last_page_fetched,
      }

    case GET_ADMIN_USERS_SUCCESS:
      let uniqueClientUsers = [];
      const all_client_users = action.payload.data || []
      all_client_users.forEach(function (item) {
        const i = uniqueClientUsers.findIndex(x => x.id == item.id);
        if (i <= -1) {
          uniqueClientUsers.push(item);
        }
      });

      return {
        ...state,
        admin_manage_clients: uniqueClientUsers,
        last_page_fetched: parseInt(action.payload.additional_data?.page_number),
        total_number_of_pages: parseInt(action.payload.additional_data?.total_number_of_pages),
        total_client_users: parseInt(action.payload.additional_data?.total_client_users),
        admin_manage_clients_loading: false
      }

    case GET_ADMIN_USERS_ERROR:
      return {
        ...state,
        admin_manage_clients_error: action.payload,
        admin_manage_clients_loading: false
      }

    case GET_REGISTRATION_PENDING_USERS:
      return {
        ...state,
        registration_pending_users_loading: true
      }

    case GET_REGISTRATION_PENDING_USERS_SUCCESS:
      return {
        ...state,
        registration_pending_users: action.payload,
        registration_pending_users_loading: false
      }

    case GET_REGISTRATION_PENDING_USERS_ERROR:
      return {
        ...state,
        registration_pending_users_error: action.payload,
        registration_pending_users_loading: false
      }

    case GET_OLD_ADMIN_USERS:
      return {
        ...state,
        loading: true
      }

    case GET_OLD_ADMIN_USERS_SUCCESS:
      return {
        ...state,
        admin_users: action.payload,
        loading: false
      }

    case GET_OLD_ADMIN_USERS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_CLIENT_USERS_BY_ACCOUNT_ID:
      return {
        ...state,
        client_users_by_account_loading: true
      }

    case GET_CLIENT_USERS_BY_ACCOUNT_ID_SUCCESS:
      return {
        ...state,
        client_users_by_account: action.payload,
        client_users_by_account_loading: false,
      }

    case GET_CLIENT_USERS_BY_ACCOUNT_ID_ERROR:
      return {
        ...state,
        client_users_by_account_error: action.payload,
        client_users_by_account_loading: false
      }
    case RESET_LAST_COMPLETED_ACTION:
      return {
        ...state,
        client_users_by_account: null,
        error: null,
      };

    case UPDATE_CLIENTS:
      return {
        ...state,
      }

    case UPDATE_CLIENTS_SUCCESS:
      {
        // get the ids of users in payload
        const payload_client_ids = action.payload.map(client => client.id);
        // create a new array of admin users without those ids
        const unchanged_clients = state.admin_manage_clients.filter(client => !payload_client_ids.includes(client.id))

        return {
          ...state,
          admin_manage_clients: [...unchanged_clients, ...action.payload],
          loading: false
        }
      }

    case UPDATE_CLIENTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case CREATE_ADMIN_RECENT_VISIT:
      return {
        ...state,
      }

    case CREATE_ADMIN_RECENT_VISIT_SUCCESS:
      {
        return {
          ...state,
          admin_recent_visits: action.payload,
          loading: false
        }
      }

    case CREATE_ADMIN_RECENT_VISIT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_ADMIN_RECENT_VISIT:
      return {
        ...state,
      }

    case GET_ADMIN_RECENT_VISIT_SUCCESS:
      {
        return {
          ...state,
          admin_recent_visits: action.payload,
          loading: false
        }
      }

    case GET_ADMIN_RECENT_VISIT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case SEND_ADMIN_CLIENT_INVITE_MAIL:
      return {
        ...state,
        invite_mailer_loading: true
      }
    case SEND_ADMIN_CLIENT_INVITE_MAIL_SUCCESS:
      {
        // get the ids of users in payload
        const payload_client_ids = action.payload.map(client => client.id);
        // create a new array of admin users without those ids
        const unchanged_clients = state.admin_manage_clients.filter(client => !payload_client_ids.includes(client.id))

        return {
          ...state,
          invite_mailer_loading: false,
          admin_manage_clients: [...unchanged_clients, ...action.payload],
        }
      }
    case SEND_ADMIN_CLIENT_INVITE_MAIL_ERROR:
      return {
        ...state,
        invite_mailer_loading: false
      }

    case DELETE_REGISTRATION_PENDING_USER:
      return {
        ...state,
        registration_pending_users_loading: true
      }

    case DELETE_REGISTRATION_PENDING_USER_SUCCESS:
      return {
        ...state,
        registration_pending_users: action.payload.id ? state.registration_pending_users.filter(user => user.id !== action.payload.id) : state.registration_pending_users,
        registration_pending_users_loading: false
      }

    case DELETE_REGISTRATION_PENDING_USER_ERROR:
      return {
        ...state,
        registration_pending_users_error: action.payload,
        registration_pending_users_loading: false
      }
    default:
      return state
  }
}

export default AdminUsers;
